import Settings from './SettingsExpandableList';
import LivePreview from './BannerLivePreview';

export const BannerSettings = Settings;
export const BannerLivePreview = LivePreview;